<template>
  <div>
    <b-button
      id="btn-open-tools"
      v-b-toggle.tools-sidebar
      class="px-5"
    >
      Tools
    </b-button>
    <b-sidebar
      id="tools-sidebar"
      v-model="toolsVisible"
      class="mb-2"
      title="Tools"
      right
      shadow
      width="25rem"
      :no-close-on-esc="true"
      :no-close-on-route-change="true"
      @hidden="saveConfiguration"
      @shown="validateRightPosition"
    >
      <b-tabs
        content-class="tools-edit"
        justified
        no-float
        @activate-tab="tabSelectionChanged"
      >
        <b-tab
          title="Files"
          active
        >
          <ToolsFilesSection />
        </b-tab>
        <b-tab title="Properties">
          <ToolsProperties />
        </b-tab>
        <b-tab
          title="Templates"
        >
          <ToolsLayoutSection
            ref="layoutSection"
            @reportDeepChange="$emit('reportDeepChange')"
          />
        </b-tab>
      </b-tabs>
    </b-sidebar>
  </div>
</template>

<script>
import ToolsFilesSection from '@/components/properties/ToolsFilesSection'
import ToolsProperties from '@/components/properties/ToolsProperties'
import ToolsLayoutSection from '@/components/properties/ToolsLayoutSection'
import { mapActions,mapGetters } from 'vuex'
import $ from 'jquery'
import { getReportFiles } from '@/common/commonFunctions.js';


export default {
  name: 'ToolsEdit',
  components: {
    ToolsFilesSection,
    ToolsProperties,
    ToolsLayoutSection
  },
  computed: {
    ...mapGetters([
      'isVisibleLearningCntxlHelp',
      'getWidthLearningCntxHelp',
      'getCurrentReportViewer',
      'isReportConfigModifiedReportViewer',
      'isToolSideBarVisibleReportViewer',
      'getInitReqConfWindow'
    ]),
    toolsVisible:{
      set (value) {
        this.setToolSideBarVisibleReportViewer(value)
      },
      get () {
        return this.isToolSideBarVisibleReportViewer
      }
    }
  },
  watch: {
    isVisibleLearningCntxlHelp(){
      this.validateRightPosition()
    },
    isReportConfigModifiedReportViewer(newVal){
      if (newVal){
        $('#tools-sidebar').css({'border': 'solid 1px #008800'});
      }else{
        $('#tools-sidebar').css('border', '');
      }
    }
  },
  methods:{
    ...mapActions([
      'setGraphsConfWindow',
      'setForceUpdateReportViewer',
      'setConfigReportModifiedReportViewer',
      'setToolSideBarVisibleReportViewer',
      'resetInitReqConfWindow'
    ]),
    tabSelectionChanged(newTabIndex){
      if(newTabIndex===2){
        this.$refs.layoutSection.updateTable()
      }
    },
    async saveConfiguration(){
      //Validate the user has some files
      const reportFiles =  await getReportFiles(this.getCurrentReportViewer)
      if(reportFiles.length === 0){
        try{
          await this.$confirm(
            'It will not show any cards. Are you sure?',
            'Any files added',
            'question',
            {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }
          )
        }
        catch{
          this.$root.$emit('bv::toggle::collapse', 'tools-sidebar')
          return
        }
      }
      if(!this.isReportConfigModifiedReportViewer){
        return
      }

      //Get a common variable of the required initialization (such as ConcTimes or AoI)
      const plotsToConfigure = this.getInitReqConfWindow
      this.resetInitReqConfWindow()
      this.getCurrentReportViewer.dateLastUpdate = new Date().toLocaleString()
      this.getCurrentReportViewer.isReady=false
      if(plotsToConfigure.length>0){
        this.setGraphsConfWindow(plotsToConfigure)
      }
      else{
        this.getCurrentReportViewer.isReady=true
        this.setForceUpdateReportViewer(1)
      }

    },
    validateRightPosition(){
      const rightPos = this.isVisibleLearningCntxlHelp?this.getWidthLearningCntxHelp:'0px'
      $('#tools-sidebar').css('right', rightPos); //It should be in this way because the style property in bsidebar is not moved to the actual DIV
    }
  }
}
</script>

<style lang="scss" scoped >
::v-deep #tools-sidebar{
  top: 7rem;
  height: 80vh !important;
  border-radius: 0px 20px 0px 20px;
	margin-right: 0.5rem;
}
::v-deep .b-sidebar-header{
  color: #FFF;
  background-color: #388A32;
  text-align: center;
  display: block !important;
}

::v-deep .close {
  margin-right: 0 !important;
  position: absolute !important;
  right: 0.75rem !important;
  stroke-width: 1.5;
  stroke: white;
  border-radius: 20px 0px 0px 0px;
}

::v-deep #sidebar-right___title__{
    text-align: center;
    width: 100%;
}

::v-deep .nav-item{
  padding: 0;
}

::v-deep .nav-link{
  color:#777
}
::v-deep .nav-link:hover{
  color:#555;
  background-color: #DDD;
}

::v-deep .card-header{
  padding-top: 0rem;
  padding-bottom: 0rem;
}

#btn-open-tools{
  background-color: #388A32;
  font-size: 1.2em;
  font-weight: bold;
}

</style>
